import script from "./LegalNotice.vue?vue&type=script&setup=true&lang=js"
export * from "./LegalNotice.vue?vue&type=script&setup=true&lang=js"

import "./LegalNotice.vue?vue&type=style&index=0&id=e418f2ac&scoped=true&lang=scss"

import exportComponent from "/Volumes/Quoicoubeh/Paraleclypse/website/paraleclypse/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e418f2ac"]])

export default __exports__